const firebaseConfig = {
    apiKey: "AIzaSyD2nbKG3YX76Q35Pqjn9hY3ucX8raNHKZ4",
    authDomain: "doctor-s-portal-9cc4d.firebaseapp.com",
    databaseURL: "https://doctor-s-portal-9cc4d.firebaseio.com",
    projectId: "doctor-s-portal-9cc4d",
    storageBucket: "doctor-s-portal-9cc4d.appspot.com",
    messagingSenderId: "1053381379764",
    appId: "1:1053381379764:web:ff5d112a76a9231ade39e1"
};

export default firebaseConfig;